import { Layout } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const StyledContent = styled(Layout.Content)`
  display: flex;
  flex-direction: column;

  & > div {
    gap: ${({ theme }) => theme.size.space['04']};
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.size.space['03']};
`
